import { render, staticRenderFns } from "./mortgageStatus.vue?vue&type=template&id=646772b2&scoped=true&lang=html&"
import script from "./mortgageStatus.vue?vue&type=script&lang=js&"
export * from "./mortgageStatus.vue?vue&type=script&lang=js&"
import style0 from "./mortgageStatus.vue?vue&type=style&index=0&id=646772b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646772b2",
  null
  
)

export default component.exports